// extracted by mini-css-extract-plugin
export var collaboratorsSection = "footer-module--collaborators-section--8655b";
export var container = "footer-module--container--9f894";
export var contributor = "footer-module--contributor--b20c0";
export var generation = "footer-module--generation--1e09b";
export var institution = "footer-module--institution--3dbfd";